export default "__VITE_ASSET__vgDEtDE5__"